<template>
  <input
    v-bind="$attrs"
    ref="input"
    class="pac-target-input"
    type="text"
    autocomplete="off"
  >
</template>

<script>
import { loadGoogleMaps } from './googleMapsLoader'

export default {
  name: 'GmapAutocomplete',
  inheritAttrs: false,
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      autocomplete: null,
      autocompleteListener: null
    }
  },
  async mounted () {
    const google = await loadGoogleMaps()

    if (typeof google.maps?.places?.Autocomplete !== 'function') {
      throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?')
    }

    this.autocomplete = new google.maps.places.Autocomplete(this.$refs.input, this.options)
    this.autocompleteListener = this.autocomplete.addListener('place_changed', () => {
      this.$emit('place_changed', this.autocomplete.getPlace())
    })
  },
  beforeUnmount () {
    if (this.autocompleteListener) {
      this.autocompleteListener.remove()
    }
  }
}
</script>
